import { initialState } from "./state";

export const news = (state = initialState, action) => {
  switch (action.type) {
    case "SET_NEWS_LIST": {
      return Object.assign({}, state, {
        newsList: action.data,
      });
    }
    case "SET_ACTIVE_NEWS_DETAIL": {
      return {
        ...state,
        activeNewsDetail: action.data,
      };
    }
    default:
      return state;
  }
};
